import {defaultMarkdownParser, MarkdownParser} from 'prosemirror-markdown';
import markdownIt from 'markdown-it';
import markdownItMark from 'markdown-it-mark';
import markdownItContainer from 'markdown-it-container';
import markdownItAttrs from 'markdown-it-attrs';
import markdownItDefList from 'markdown-it-deflist';
import {markdownCheckboxes} from './markdown/markdownCheckboxes';
import {markdownMath} from './markdown/markdownMath';
import {codeContainer} from './markdown/markdownContainer';
import {markdownUnderline} from './markdown/markdownUnderline';
import {markdownEmoji} from './markdown/markdownEmoji';
import {Node} from 'prosemirror-model';
import {markdownTable} from './markdown/markdownTable';
import {markdownHtmlTable} from './markdown/markdownHtmlTable';
import {markdownTableOfContents} from './markdown/markdownTableOfContents';
import {markdownHtmlGrid} from './markdown/markdownHtmlGrid';
import {markdownLabel} from './markdown/markdownLabel';
import {markdownRelativeTime} from './markdown/markdownRelativeTime';
import {markdownHtmlCard} from './markdown/markdownHtmlCard';
import {markdownHtmlAccordion} from './markdown/markdownHtmlAccordion';

export const documentNode = (documentSchema, doc, nodeParsers, markParsers, parserPlugins = []) => {
    if (doc) {
        if (typeof doc === "string") {
            return markdownParser(documentSchema, nodeParsers, markParsers, parserPlugins).parse(doc);
        } else {
            return Node.fromJSON(documentSchema, doc);
        }
    } else {
        return documentSchema.nodes.doc.createAndFill();
    }
};

export const markdownParser = (documentSchema, nodeParsers, markParsers, parserPlugins = []) => {
    const tokenizer = markdownIt({html: false, typographer: true, linkify: true})
        .enable(['strikethrough'])
        .use(markdownUnderline)
        .use(markdownLabel)
        .use(markdownEmoji)
        .use(markdownHtmlAccordion)
        .use(markdownTable)
        .use(markdownCheckboxes)
        .use(markdownMath)
        .use(markdownItMark)
        .use(markdownItDefList)
        .use(markdownItAttrs, {
          allowedAttributes: [
            'width',
            'height',
            'class',
            'data-id',
            'data-size',
            'data-type',
            'data-diagram',
            'data-color',
            'data-content',
          ],
        })
        .use(markdownHtmlTable)
        .use(markdownHtmlGrid)
        .use(markdownHtmlCard)
        .use(markdownItContainer, 'message')
        .use(md => {
            md.block.ruler.before('fence', 'code_container_mermaid', codeContainer('mermaid'));
        })
        .use(md => {
            md.block.ruler.before('fence', 'code_container_plantuml', codeContainer('plantuml'));
        })
        .use(markdownTableOfContents)
        .use(markdownRelativeTime);

    parserPlugins.forEach(parserPlugin => tokenizer.use(parserPlugin));

    return new MarkdownParser(
        documentSchema,
        tokenizer, {
            ...defaultMarkdownParser.tokens,
            ...nodeParsers,
            ...markParsers,
            link: {
                mark: "link", getAttrs: function (token) {
                    return {
                        ['data-id']: token.attrGet("data-id") || null,
                        ['data-size']: token.attrGet("data-size") || null,
                        ['data-type']: token.attrGet("data-type") || null,
                        href: token.attrGet("href"),
                        title: token.attrGet("title") || null,
                        color: token.attrGet("data-color") || null,
                        button: token.attrGet("class")?.includes("button") || false
                    };
                }
            }
        }
    );
};